import React from "react";
import { SignaturePad as Pad } from "../SignaturePad";

export const SignaturePad = ({ title, testid, onChange }) => (
  <Pad label={<>{title} <span className="text-destructive">*</span></>} testid={testid} onChange={onChange} />
);
